import Kai from '../assets/images/Kai-Mykkanen.jpeg'
import Nora from '../assets/images/Nora-Huovila.jpeg'
import Ville from '../assets/images/Ville-Kaituri.jpeg'
import Patrik from '../assets/images/Patrik-Fingerroos.jpg'
import Inari from '../assets/images/Inari-Otonkoski.jpg'
import Rikumatti from '../assets/images/Rikumatti-Forsberg.jpeg'
import Matti from '../assets/images/Matti-Santala.jpeg'
import Kalle from '../assets/images/Kalle-Lagerblom.jpeg'
import Nhamo from '../assets/images/Nhamo-Zinhu.jpg'
import Erik from '../assets/images/Erik-Rousi.jpeg'
import Risto from '../assets/images/Risto-Rautava.jpeg'
import Jaana from '../assets/images/Jaana-Aalto-Setala.jpeg'
import Valtteri from '../assets/images/Valtteri-Torikka.jpeg'
import Elina from '../assets/images/Elina-Lepomaki.jpeg'
import Anders from '../assets/images/Anders-Brotherus.jpeg'
import Jasu from '../assets/images/Jasu-Koponen.jpeg'
import Tareq from '../assets/images/Tareq.jpeg'
import Jessica from '../assets/images/Jessica.jpeg'
import Esa from '../assets/images/Esa.jpg'
import Henrikki from '../assets/images/Henrikki.jpeg'
import Tomer from '../assets/images/Tomer.jpeg'

const supporters = [
  {
    author: 'Kai Mykkänen',
    text:
      'Danielilla on kyky nähdä haasteet mahdollisuuksina ja viedä ideat toteutukseen. Näytöt puhuvat puolestaan. Tätä osaamista tarvitaan Arkadianmäelle!',
    image: Kai,
    details: 'Sisäministeri',
  },
  {
    author: 'Elina Lepomäki',
    text:
      'Oli ilo kuulla, että Daniel pyrkii eduskuntaan. Tunnemme toisemme start-up-maailmasta, jossa ratkaisukeskeisyys ja sisu ovat kaikki kaikessa. Danielilla on niistä molempia!',
    image: Elina,
    details: 'Kansanedustaja',
  },
  {
    author: 'Nora Huovila',
    text:
      'Olen tuntenut Danielin 15 vuotta, joiden aikana hänestä on tullut läheinen ystävä. Daniel on fiksu, rohkea ja hyväsydäminen. Hän ansaitsee isomman platformin, jossa ajaa muutosta. Daniel saa ehdottomasti minun ääneni. Toivottavasti sinunkin :)',
    image: Nora,
    details: 'Toimitusjohtaja',
  },

  {
    author: 'Esa Saarinen',
    text:
      'Onnea matkaan Eduskuntavaalikampanjaasi Daniel! Sinun inhimillinen lämpösi, luova ja rakentava älysi, ystävällinen sosiaalisuutesi, kykysi kunnioittaa erilaisuutta ja uskosi yhteistyöhön, on sitä otetta mitä Suomi nyt tarvitsee!',
    image: Esa,
    details: 'Filosofi',
  },
  {
    author: 'Erik Rousi',
    text:
      'Tulevaisuuden globaaliin maailmaan kuuluvan Suomen rakentamiseen tarvitaan Danielin kaltaisia rohkeita uudistajia. Daniel jakaa arvoni modernissa ympäristö-, maahanmuutto-, talous- ja kulttuuripolitiikassa.',
    image: Erik,
    details: 'Oopperalaulaja',
  },
  {
    author: 'Jaana Aalto-Setälä',
    text:
      'Daniel ehdottomasti eduskuntaan! Daniel on todistettavasti ja konkreettisesti saanut aikaan kotouttamista, jossa voittavat sekä ihminen että Suomi itse. Olen myös useista asioista Danielin kanssa tasan samaa mieltä. Tuo Daniel nuuska kauppoihin!',
    image: Jaana,
    details: 'Tuottaja',
  },
  {
    author: 'Ville Kaituri',
    text:
      'Daniel on vanha yhtiökumppanini ja ystäväni. Daniel on luova ongelmanratkaisija, sinnikäs yrittäjä ja hänellä on hyvin laaja verkosto. Nämä ominaisuudet mahdollistavat asioiden aikaansaamisen. Tämän vuoksi äänestän Danielia.',
    image: Ville,
    details: 'Yrittäjä',
  },

  {
    author: 'Inari Otonkoski',
    text:
      'Minulla on ollut ilo tuntea Daniel jo yli 10 vuoden ajan. Daniel on sinnikäs, tulevaisuuteen positiivisesti suhtautuva yrittäjä sekä lojaali ja luotettava ystävä. Tulevissa vaaleissa taloutemme kestävyysvaje ja yhteiskuntamme resurssien ja potentiaalin hyödyntäminen tulevat olemaan keskeisinä teemoina. Tämän vuoksi kannattaa äänestää Danielia, jolla on oikeasti toteutuskelpoisia ja toimivia ratkaisuja Suomen haasteisiin.',
    image: Inari,
    details: 'KTM',
  },
  {
    author: 'Tareq Mahmoud',
    text:
      'Integrify changed my life. Before Integrify I had trouble getting into the job market and now I am working as a software developer thanks to Integrify. I was lucky to get to the program. Daniel really understands key factors to successful integration and has innovative ideas that he can execute.',
    image: Tareq,
    details: 'Software Developer',
  },
  {
    author: 'Rikumatti Forsberg',
    text:
      'Talousasiat ovat minulle tärkeitä. Danielilla on hyvä ymmärrys taloudesta, kyky nähdä kokonaisuus ja tehdä johtopäätökset sen mukaan. Suomi tarvitsee enemmän Danielin kaltaisia talouden ymmärtäjiä päättäjiksi!',
    image: Rikumatti,
    details: 'Partner',
  },
  {
    author: 'Patrik Fingerroos',
    text:
      'Tunnen Danielin yli kahdenkymmenen vuoden takaa. Hän on luotettava ystävä, optimistinen ajattelija sekä älykäs ongelmanratkaisija. Tarvitsemme Danielin kaltaisia henkilöitä päättämään Suomen tulevaisuudesta!',
    image: Patrik,
    details: 'Liikkeenjohdon konsultti',
  },
  {
    author: 'Jessica Blechingberg',
    text:
      'Olen tutustunut Danieliin startup piireistä ja hänen kanssa on aina ollut ilo tehdä yhteistyötä. Danielin positiivinen asenne ja tapa ratkaista ongelmia on ihailtavaa. Jos joku saa muutoksia aikaiseksi, se on Daniel.',
    image: Jessica,
    details: 'Country Manager',
  },
  {
    author: 'Anders Brotherus',
    text:
      'Oy Suomi Ab vetää viimeisiään, eikä suurin uhka olekaan ilmastonmuutos. Yhteiskuntamme johtoryhmässä keskusteluja pitää käydä positiiviset, ennakkoluulottomat #factfulness-realistit. Daniel on sellainen.',
    image: Anders,
    details: 'Head of Digital Services',
  },
  {
    author: 'Valtteri Torikka',
    text:
      'Danielilla on vahvat näytöt yrittäjänä yhteiskunnallisten asioiden ratkaisuissa. Eduskunta tarvitsee enemmän tekijöitä. Siksi Daniel!',
    image: Valtteri,
    details: 'Toimitusjohtaja',
  },
  {
    author: 'Matti Santala',
    text: 'Rahman rokkaa!',
    image: Matti,
    details: 'Yrittäjä',
  },
  {
    author: 'Nhamo Zinhu',
    text:
      'Daniel on lapsuudenystävä ja purjehduskaverini. Hän on kokenut yrittäjä ja saa todella asioita aikaiseksi.',
    image: Nhamo,
    details: 'Opiskelija',
  },
  {
    author: 'Jasu Koponen',
    text:
      'Danielilla on käsittämätön kyky, draivi ja uskallus viedä maaliin tärkeitä asioita, jotka moni muu kokee mahdottomiksi.',
    image: Jasu,
    details: 'Yrittäjä',
  },
  {
    author: 'Kalle Lagerblom',
    text:
      'Daniel on hyvin postiivinen ja aikaansaava ihminen, joka on hyvin perillä modernin yhteiskunnan toiminnasta ja siihen liittyvistä haasteista. Annan ääneni Danielle, koska uskon modernin järjen ääneen.',
    image: Kalle,
    details: 'Tutkija, PhD.',
  },
  {
    author: 'Risto Rautava',
    text:
      'Daniel on raikas tuulahdus Kokoomukselle politiikan sisäpiirin ulkopuolelta. Hän tuo mukanaan tarvittavaa yrittäjähenkisyyttä ja uudistushenkeä.',
    image: Risto,
    details: 'Helsingin kaupunginvaltuutettu',
  },
  {
    author: 'Henrikki Tikkanen',
    text:
      'Olen oppinut tuntemaan Danielin ahkerana, fiksuna ja markkinamyönteisenä ajattelijana, joka uskaltaa kritisoida vallitsevia käytäntöjä. Minun on ilo suositella entistä opiskelijaani ja tutkimusassistenttiani Danielia eduskuntaan.',
    image: Henrikki,
    details: 'Professori, Aalto-yliopisto',
  },
  {
    author: 'Tomer Hovav',
    text:
      'Suomen tulevaisuus tarvitsee avarakatseisia, nuoria, fiksuja, sekä kriittisesti ajattelevia päättäjiä. Sellaisia päättäjiä, joilla on hyvä arvomaailma ja jotka ovat valmiita tekemään sekä rohkeita, että oikeita päätöksiä. Daniel on ehdottomasti valintani, toivottavasti sinunkin!',
    image: Tomer,
    details: 'Yrittäjä',
  },
]

export default supporters
